/**
 * ItemMenuHandler.js - 道具菜单处理模块
 * 处理道具菜单的逻辑
 */
import ItemSystem from './ItemSystem.js';

export default class ItemMenuHandler {
    constructor(scene, menuUI) {
        this.scene = scene;
        this.menuUI = menuUI;
    }

    /**
     * 使用道具
     */
    useItem(item, playerData, onUpdate) {
        if (!item || !playerData) {
            this.menuUI.showMessage('无法使用道具', '#ff0000');
            return;
        }

        // 如果物品是合并后的（有 items 数组），使用第一个实际物品
        const actualItem = item.items && item.items.length > 0 ? item.items[0] : item;

        // 检查是否可以使用的道具
        if (!ItemSystem.canUseItem(actualItem, playerData)) {
            this.menuUI.showMessage('当前无法使用该道具', '#ffaa00');
            return;
        }

        // 使用道具
        const result = ItemSystem.useItem(actualItem, playerData);

        if (result.success) {
            // 从背包中移除道具（消耗品使用后消失）
            if (actualItem.type === 'consumable') {
                ItemSystem.removeFromInventory(actualItem, playerData.inventory);
            }

            // 显示成功消息
            this.menuUI.showMessage(result.message, '#00ff00');

            // 更新菜单显示
            if (onUpdate) {
                this.scene.time.delayedCall(500, () => {
                    onUpdate();
                });
            }
        } else {
            // 显示失败消息
            this.menuUI.showMessage(result.message, '#ff0000');
        }
    }
}

